import { Label } from 'components/atoms';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { PiEnvelopeSimple, PiHandCoinsBold, PiReceiptFill } from 'react-icons/pi';
import { EMAIL_SEND } from 'services/types';
import { IColorProp } from 'types/components/components.interface';

export interface ILabeledStatusProps {
  status: EMAIL_SEND;
}

interface ILabeledStatusParams extends IColorProp {
  status: EMAIL_SEND;
  icon: ReactNode;
}

const labeledStatusParams: ILabeledStatusParams[] = [
  {
    status: EMAIL_SEND.notSend,
    color: 'gray',
    icon: <PiEnvelopeSimple />,
  },
  {
    status: EMAIL_SEND.planned,
    color: 'blue',
    icon: <PiEnvelopeSimple />,
  },
  {
    status: EMAIL_SEND.send,
    color: 'green',
    icon: <PiEnvelopeSimple />,
  },
  {
    status: EMAIL_SEND.deleted,
    color: 'red',
    icon: <PiEnvelopeSimple />,
  },
  {
    status: EMAIL_SEND.emailNotExist,
    color: 'red',
    icon: <PiEnvelopeSimple />,
  },
  {
    status: EMAIL_SEND.error,
    color: 'red',
    icon: <PiEnvelopeSimple />,
  },
];

const LabeledEmailSend = ({ status }: ILabeledStatusProps) => {
  const { t } = useTranslation();
  const labeledParams =
    labeledStatusParams.find(params => params.status === status) ??
    labeledStatusParams[0];

  return (
    <Label
      size='compact'
      color={labeledParams.color}
      title={t(`${labeledParams.status}`)}>
      {labeledParams.icon}{' '}
      {t(`enum.EMAIL_SEND.${EMAIL_SEND[labeledParams.status]}`)}
    </Label>
  );
};

export default LabeledEmailSend;
